var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 6H11V8H13V6Z",
    fill: "#FFA556"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 10H11V18H13V10Z",
    fill: "#FFA556"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 5V4H20V3H19V2H5V3H4V4H3V5H2V19H3V20H4V21H5V22H19V21H20V20H21V19H22V5H21ZM20 17H19V18H18V19H17V20H7V19H6V18H5V17H4V7H5V6H6V5H7V4H17V5H18V6H19V7H20V17Z",
    fill: "#FFA556"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/InfoIcon.37879353511469e39ed5f9f4c1e0989a.svg";
export { ForwardRef as ReactComponent };